import { ProfileStructure } from 'structure/profile';
import { component, demoFile } from 'system/demo';

import { ProfileArticleRecommendationBox } from '../profile-article-recommendations';
import { ProfileConversationRecommendationBox } from '../profile-conversation-recommendations';

const article = { key: 'a1', title: 'News Story', image: 'https://psi.zdf.de/faces/face1.jpeg', tags: ['tech'] };

demoFile('open-modules/zdf/feature/profile-recommendations');

component('ProfileArticleRecommendationBox', ProfileArticleRecommendationBox, {
    structureKey: 'profile',
    config: ProfileStructure.receivesConfigDefaults,
    state: {
        personaKey: 'p1',
        serverCall: {
            interests: {
                getInterestingArticles: async () => [article],
            },
        },
        globals: { name: 'Alice Adams' },
        language: 'english',
    },
});

component('ProfileConversationRecommendationBox', ProfileConversationRecommendationBox, {
    structureKey: 'profile',
    config: ProfileStructure.receivesConfigDefaults,
    state: {
        collections: {
            commentrecommendation: [{ commentKey: 'c1', tags: ['tech'], article }],
            comment: [{ key: 'c1', from: 'u2', text: 'Check this out' }],
        },
        serverCall: {},
        globals: { name: 'Alice Adams' },
        language: 'english',
    },
});
